import { render, staticRenderFns } from "./Setting10.vue?vue&type=template&id=4740c3e7&"
import script from "./Setting10.vue?vue&type=script&lang=js&"
export * from "./Setting10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports